import { HierarchyContext } from "contexts/HierarchyContext";
import { eHierarchyLevel } from "functions/api/enums";
import { useContext } from "react";
import { ArsLinks } from "./ArsLinks";
import { ChildLinks } from "./ChildLinks";
import { ParentLink } from "./ParentLink";
import { RecentLinks } from "./RecentLinks";
import { StudyTree } from "./StudyTree";
import { TypeLinks } from "./TypeLinks";

/**
 * Grouped navigation links for the hierarchy page, combining type, parent,
 * child and recent links into a single sidebar section.
 */
export const HierarchyLinks = () => {
  const hierarchyContext = useContext(HierarchyContext);
  const showStudyTree =
    hierarchyContext?.hierarchy?.level === eHierarchyLevel.Study ||
    hierarchyContext?.hierarchy?.level === eHierarchyLevel.Report;
  return (
    <>
      <TypeLinks />
      <ArsLinks />
      <hr className="mt-3" />
      <ParentLink />
      {showStudyTree ? <StudyTree /> : <ChildLinks />}
      <RecentLinks />
    </>
  );
};

HierarchyLinks.displayName = "HierarchyLinks";
